<h2 mat-dialog-title class="dialog-title">{{ data.title }}</h2>
<div mat-dialog-content>
    <div [innerHTML]="data.message"></div>
</div>
<div class="footer-wrapper" mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ data.cancelLabel }}</button>
    <button [color]="data.confirmColor ?? 'primary'" mat-button (click)="confirm()">{{ data.confirmLabel }}</button>
</div>
